import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { GrnNumberDto } from './grn-number.dto';


export class GrnNumberResponseModel extends GlobalResponseObject {
    data?: GrnNumberDto[];
    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, intlCode: number, internalMessage: string, data?: GrnNumberDto[]){
        super(status,intlCode,internalMessage)
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

